export const DocumentTabs = Object.freeze({
  UPLOADED: {
    text: 'Uploaded',
  },
  DELETED: {
    text: 'Deleted',
  },
  ALL: {
    text: 'All',
  },
});

export const DefaultTabInfo = Object.freeze({
  UPLOADED: {
    text: DocumentTabs.UPLOADED.text,
    count: 0,
  },
  DELETED: {
    text: DocumentTabs.DELETED.text,
    count: 0,
  },
  ALL: {
    text: DocumentTabs.ALL.text,
    count: 0,
  },
});

export const TableHeaders = [
  { column: 'fileName', label: 'File Name', width: '25%', sortBy: 'text' },
  { column: 'fileType', label: 'Type', width: '15%', sortBy: 'text' },
  { column: 'fileCategory', label: 'Category', width: '15%', sortBy: 'text' },
  { column: 'uploadedAt', label: 'Uploaded At', width: '13%', sortBy: 'value' },
  { column: 'uploadedBy', label: 'Uploaded By', width: '18%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '14%' },
];
